import React from "react";
import Config from "./Config";


export default function Preloader() {
    let loaderText = 'Bitte warten…';

    if (document.documentElement.lang === 'en-US') {
        loaderText = 'Please wait...';
    }
    return (
        <div className="preloader-wrapper">
            <img src={Config('ASSETS_URL')+'/images/preloader.gif'}/>
            <h1>{loaderText}</h1>
        </div>
    )
}